import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  allowedRoles?: number[];
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  allowedRoles = [],
  children,
}) => {
  const userString = localStorage.getItem("user");
  const token = localStorage.getItem("token");

  if (!userString || !token) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/" replace />;
  }

  const user = JSON.parse(userString);
  const userRole: number = user?.role_name;

  const isAuthorized =
    allowedRoles.length === 0 || allowedRoles.includes(userRole);

  if (!isAuthorized) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
